export class ErrorWithData<T> extends Error {
  data?: T;
  constructor(message: string, data?: T) {
    super(message);
    this.name = "ErrorWithData";
    this.data = data;
  }
}
